import React, { useEffect, useState } from 'react';
import {
  AppstoreOutlined,
  ArrowRightOutlined,
  BookOutlined,
  CopyOutlined,
  DollarOutlined,
  HomeFilled,
  LogoutOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  ProjectOutlined,
  QuestionCircleOutlined,
  UserOutlined,
  FileSearchOutlined,
  FileProtectOutlined,
} from '@ant-design/icons';
import type { MenuProps } from 'antd';
import LoadingOverlay from 'react-loading-overlay-ts';

import R from './picture/LOGOVU.png'
import { Anchor, Button, ConfigProvider, Dropdown, Flex, FloatButton, Layout, Menu, Modal, theme } from 'antd';  
import { Outlet, useLocation, useParams} from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import axios from "axios";

const { Header, Sider, Content } = Layout;


//ออกจากระบบ
function signout() {
  sessionStorage.clear();
  window.location.href = "/VRIIS";
}

const siderStyle: React.CSSProperties = {
  height: '100vh',
  position: 'fixed',
  left: 0,
  top: 0,
  bottom: 0,
  zIndex: 1000, // Ensure it stays above the content
  overflow: 'auto',
  scrollbarWidth: 'thin',
};

export function Staffbar(){
    type MenuItem = Required<MenuProps>['items'][number];
    const [openMod,setopenMod] = useState(false)
  
    const [imgdata,setimg] = useState();

    const [collapsed, setCollapsed] = useState(false);
    const location = useLocation();
    const MenuKey = location.pathname;
    const navigate = useNavigate();

    const { user,project_id,progress_id } = useParams();
    const iscommitteeinfopage = location.pathname === `/VRIIS/CommitteeReqInfo/${user}/${project_id}`
    const isstaffinfopage = location.pathname === `/VRIIS/StaffBudgetReq/${user}/${project_id}`
    const isHome = location.pathname === `/VRIIS`
    const isHome2 = location.pathname === `/VRIIS/`
    const isPReportHome = location.pathname === `/VRIIS/ProgressReportList` 
    const isPReportHome2 = location.pathname ===  `/VRIIS/ProgressReportReview/${progress_id}` 
    const isCReportHome = location.pathname === `/VRIIS/CompletionReportStaffCheck`
    const isPReport = location.pathname === `/VRIIS/ProgressReportReview/${project_id}`
    const isCReport = location.pathname === `/VRIIS/CompletionReportReview/${progress_id}`
    const isDashboard = location.pathname === `/VRIIS/StaffReportDashboard` 
    const isDashboard2 = location.pathname === `/VRIIS/StaffReportDashboard/` 

    const {
        token: { colorBgContainer, borderRadiusLG },
      } = theme.useToken();
      const handleMain = () => {
        navigate(`/VRIIS`);
      };
      const onclickManual = async()=>{
        if(sessionStorage.getItem('role')=='staff'){
          window.open('https://www.canva.com/design/DAGcKI8z918/rUQzPbHwidAo2qJbUZfiNQ/view?utm_content=DAGcKI8z918&utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks&utlId=h923733ef64', '_blank')
        }else if(sessionStorage.getItem('role')=='commitee'){
          window.open("https://www.canva.com/design/DAGcO-Nv9sY/62dmLwwWCUZdnW1zvbyE1g/view?utm_content=DAGcO-Nv9sY&utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks&utlId=h725e7e6b0e", '_blank')
        }
      }
      const items: MenuItem[] = [
        { key: '/VRIIS', icon: <HomeFilled />, label: <a onClick={handleMain} target="_self" rel="noopener noreferrer">: หน้าหลัก</a> },
        { key: '/Help', icon: <QuestionCircleOutlined />, label: <a onClick={onclickManual} target="_self" rel="noopener noreferrer">: คู่มือการใช้งาน</a>},
        { key: '/PReport', icon: <FileSearchOutlined />, label: <a onClick={()=> navigate(`/VRIIS/ProgressReportList`)} target="_self" rel="noopener noreferrer">: รายงานความก้าวหน้า</a>},
        { key: '/logout', icon: <LogoutOutlined />, label: <a onClick={()=>setopenMod(true)}>: ออกจากระบบ</a> },
      ];

      let staffInfoitems : MenuItem[] = 
    ([
      { key: '/VRIIS', icon: <HomeFilled />, label: <a onClick={handleMain} target="_self" rel="noopener noreferrer">: หน้าหลัก</a> },
      { key: '/logout', icon: <LogoutOutlined />, label: <a onClick={()=>setopenMod(true)}>: ออกจากระบบ</a> },
      { key: '/sss', label: <hr /> , disabled:true},
      { key: 'set', icon: <AppstoreOutlined />, label: <p>ข้อมูลโครงการ</p>,children:[
        {key: '/part1', icon: <BookOutlined />, label: <a href={`/VRIIS/StaffBudgetReq/${user}/${project_id}#part-1`}><ArrowRightOutlined /> ส่วนที่ 1 ข้อมูลงานวิจัย</a>},
        {key: '/part2', icon: <UserOutlined />, label: <a href={`/VRIIS/StaffBudgetReq/${user}/${project_id}#part-2`}><ArrowRightOutlined /> ส่วนที่ 2 ข้อมูลบุคลากรที่เกี่ยวข้องกับงานวิจัย</a>},
        { key: '/part3', icon: <CopyOutlined />, label: <a href={`/VRIIS/StaffBudgetReq/${user}/${project_id}#part-3`}><ArrowRightOutlined /> ส่วนที่ 3 รายละเอียดโครงการงานวิจัย</a> },
        { key: '/part4', icon: <ProjectOutlined />, label: <a href={`/VRIIS/StaffBudgetReq/${user}/${project_id}#part-4`}><ArrowRightOutlined /> ส่วนที่ 4 ผลลัพธ์และผลกระทบ</a>},
        { key: '/part5', icon: <DollarOutlined />, label: <a href='#part-5'><ArrowRightOutlined /> ส่วนที่ 5 งบประมาณและค่าใช้จ่าย</a> },
      ]}])
  ;

  let committeeInfoitems : MenuItem[] = 
    ([
      { key: '/VRIIS', icon: <HomeFilled />, label: <a onClick={handleMain} target="_self" rel="noopener noreferrer">: หน้าหลัก</a> },
      
      { key: '/logout', icon: <LogoutOutlined />, label: <a onClick={()=>setopenMod(true)}>: ออกจากระบบ</a> },
      { key: '/sss', label: <hr /> , disabled:true},
      { key: 'set', icon: <AppstoreOutlined />, label: <p>ข้อมูลโครงการ</p>,children:[
        {key: '/part1', icon: <BookOutlined />, label: <a href={`/VRIIS/CommitteeReqInfo/${user}/${project_id}#part-1`}><ArrowRightOutlined /> ส่วนที่ 1 ข้อมูลงานวิจัย</a>},
        {key: '/part2', icon: <UserOutlined />, label: <a href={`/VRIIS/CommitteeReqInfo/${user}/${project_id}#part-2`}><ArrowRightOutlined /> ส่วนที่ 2 ข้อมูลบุคลากรที่เกี่ยวข้องกับงานวิจัย</a>},
        { key: '/part3', icon: <CopyOutlined />, label: <a href={`/VRIIS/CommitteeReqInfo/${user}/${project_id}#part-3`}><ArrowRightOutlined /> ส่วนที่ 3 รายละเอียดโครงการงานวิจัย</a> },
        { key: '/part4', icon: <ProjectOutlined />, label: <a href={`/VRIIS/CommitteeReqInfo/${user}/${project_id}#part-4`}><ArrowRightOutlined /> ส่วนที่ 4 ผลลัพธ์และผลกระทบ</a>},
        { key: '/part5', icon: <DollarOutlined />, label: <a href='#part-5'><ArrowRightOutlined /> ส่วนที่ 5 งบประมาณและค่าใช้จ่าย</a> },
      ]}])
  ;

  let Committeeitems : MenuItem[] = 
    ([
      { key: '/VRIIS', icon: <HomeFilled />, label: <a onClick={handleMain} target="_self" rel="noopener noreferrer">: หน้าหลัก</a> },
      
      { key: '/logout', icon: <LogoutOutlined />, label: <a onClick={()=>setopenMod(true)}>: ออกจากระบบ</a> },
      { key: '/sss', label: <hr /> , disabled:true},
      { key: 'set', icon: <AppstoreOutlined />, label: <p>ข้อมูลโครงการ</p>,children:[
        {key: '/part1', icon: <BookOutlined />, label: <a href={`/VRIIS/ReqInfo/${user}/${project_id}#part-1`}><ArrowRightOutlined /> ส่วนที่ 1 ข้อมูลงานวิจัย</a>},
        {key: '/part2', icon: <UserOutlined />, label: <a href={`/VRIIS/ReqInfo/${user}/${project_id}#part-2`}><ArrowRightOutlined /> ส่วนที่ 2 ข้อมูลบุคลากรที่เกี่ยวข้องกับงานวิจัย</a>},
        { key: '/part3', icon: <CopyOutlined />, label: <a href={`/VRIIS/ReqInfo/${user}/${project_id}#part-3`}><ArrowRightOutlined /> ส่วนที่ 3 รายละเอียดโครงการงานวิจัย</a> },
        { key: '/part4', icon: <ProjectOutlined />, label: <a href={`/VRIIS/ReqInfo/${user}/${project_id}#part-4`}><ArrowRightOutlined /> ส่วนที่ 4 ผลลัพธ์และผลกระทบ</a>},
        { key: '/part5', icon: <DollarOutlined />, label: <a href='#part-5'><ArrowRightOutlined /> ส่วนที่ 5 งบประมาณและค่าใช้จ่าย</a> },
      ]}])
  ;
      
      useEffect(() => {

        const setFavicon = (iconUrl: string) => {
          const link: HTMLLinkElement | null = document.querySelector("link[rel*='icon']");
          if (link) {
            link.href = iconUrl;
          } else {
            const newLink = document.createElement("link");
            newLink.rel = "icon";
            newLink.href = iconUrl;
            document.head.appendChild(newLink);
          }
        };
    
        // Set external image URL as favicon
        setFavicon("https://www.vu.ac.th/wp-content/uploads/elementor/thumbs/vu-main-logo-02-qtm90eapvkc9aj8bjqi1ltncwx61v3ygsveunoi0mu.png");
        document.title = "VRIIS"; 
        
         
      }, [location.pathname]);
      return(
        <ConfigProvider 
      theme={{
        components: {
          Table: {
            bodySortBg:"",
            headerBg:"#8EA3A6",
            rowHoverBg:"#E6E9AF",
            footerBg:"#8EA3A6",
            headerColor:"white"
          },
          Menu: {
            fontFamily: 'kanit',
            itemBg: "#white",
            itemColor: "#FFDBB5",
            itemHoverColor: "#4158A6",
            itemSelectedBg: "#FFDBB5",
            itemSelectedColor: "#8174A0",
          },
          Layout: {
            siderBg: "#5c5582",
            headerBg: "#FFD3B6",
          },
          Input: {
            activeBg: 'white',
            hoverBg: 'white',
          },
          Select: {
            optionSelectedColor: '#8174A0',
            optionActiveBg: "#E5E1DA",
            controlItemBgActive: '#E5E1DA'
        },
        },
        token: {
          fontSize: 16,
          fontFamily: 'Kanit',
          colorBgBase: '#BAB4DE',
          colorBgContainer: 'F7DCB9',
          colorBgElevated: 'white',
          colorBorder: "#179BAE",
        }
      }}
    >
      <title>VRIIS</title>
      <Layout>
        <Sider
          width={'40vh'}
          style={siderStyle}
          trigger={null}
          collapsible
          collapsed={collapsed}
        >
         <Flex justify='center'>
          <img src={R} alt="Logos" />
        </Flex>

        {/* หน้าหลัก/ดราฟท์ */}
              
        {(isHome
        ||isHome2
        ||isPReportHome
        ||isPReportHome2
        ||isCReportHome
        ||isPReport
        ||isCReport
        ||isDashboard
        ||isDashboard2
      )&&<Menu
          mode='inline'
          defaultSelectedKeys={[MenuKey]}
          // items={items}
          items={items}
          style={{ padding: 10 }}
        />}
        
        {(isstaffinfopage)&&
          <Menu
          mode='inline'
          defaultSelectedKeys={[MenuKey]}
          items={staffInfoitems}
          style={{ padding: 10 }}
        />
        }
        {(iscommitteeinfopage)&&
          <Menu
          mode='inline'
          defaultSelectedKeys={[MenuKey]}
          items={committeeInfoitems}
          style={{ padding: 10 }}
        />
        }


       </Sider>

        <Layout
          style={{
            marginLeft: collapsed ? '80px' : '40vh', // Adjust margin based on sidebar state
            transition: 'margin-left 0.2s', // Smooth transition when collapsing
          }}
        >
        <Header
            style={{
              position: 'fixed',
              top: 0,
              left: collapsed ? '80px' : '40vh', // Match the Sider's width when collapsed or expanded
              width: `calc(100% - ${collapsed ? '80px' : '40vh'})`, // Adjust width dynamically
              zIndex: 1001,
              padding: '0 16px', // Add padding for alignment
              background: '#8EA3A6',
              height: '64px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              transition: 'left 0.3s, width 0.3s', // Smooth transitions
            }}
          >

          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <Button
                type="text"
                icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                onClick={() => setCollapsed(!collapsed)}
                style={{
                  fontSize: '16px',
                  width: 64,
                  height: 64,
                }}
              />
              <p style={{ color: 'white', margin: 0 }}>
                📂 ระบบยื่นขอทุนวิจัยและนวัตกรรม มหาวิทยาลัยวงษ์ชวลิตกุล : ผู้ตรวจสอบ
              </p>
              
            </div>
            <Dropdown overlay={ <Menu>
              <Menu.Item key="logout" icon={<LogoutOutlined />} onClick={() => setopenMod(true)}>
                ออกจากระบบ
              </Menu.Item>
            </Menu>} trigger={['click']}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer' }}>
              <img
                src={sessionStorage.getItem('user_picture') || imgdata}
                alt="User"
                style={{
                  width: '40px',
                  height: '40px',
                  borderRadius: '50%',
                  objectFit: 'cover',
                }}
              />
              <p style={{ color: 'white', margin: 0 }}>{sessionStorage.getItem('fullname')}</p>
            </div>
          </Dropdown>
              </Header>

              <Content
                style={{
                  margin: '25px 70px',
                  padding: 24,
                  minHeight: '88vh',
                  background: colorBgContainer,
                  borderRadius: borderRadiusLG,
                  overflow: 'auto', // Prevent content overflow
                  marginTop: '64px',
                }}
              >
                
                <Outlet />
                <FloatButton.BackTop />
                <Modal
                title="ยืนยันการออกจากระบบ"
                open={openMod}
                onCancel={()=>setopenMod(false)}
                footer={[
                  <><Button key="back" onClick={()=>setopenMod(false)}>
                      กลับ
                  </Button><Button type='primary' danger onClick={() => signout()}>
                      ใช่
                  </Button></>
                ]}
              >
              คุณต้องการออกจากระบบใช่หรือไม่
              </Modal>
              </Content>
            </Layout>
          </Layout>
        </ConfigProvider>
      )
}